import { InternalAxiosRequestConfig } from "axios";
import { getCookieValue } from "src/constants/functions";
import { tokenStore } from "src/utils/tokenStore";

// export const addOpenfgaAuthHeader = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
//   const idToken = getCookieValue("idToken");
//   const refreshToken = getCookieValue("refreshToken");

//   if (!idToken && !refreshToken) {
//     logout();
//   }

//   if (idToken && refreshToken) {
//     config.headers["Authorization"] = JSON.stringify({
//       authorization: idToken,
//       refreshToken: refreshToken,
//     });
//   }

//   config.baseURL = config.baseURL?.toString()?.toLocaleLowerCase();
//   const [firstPart, ...rest] = config.url?.split("?") || [];
//   config.url = firstPart?.toString() + (rest.length ? "?" + rest.join("?") : "");

//   return config;
// };

export const addOpenfgaAuthHeader = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  // Prefer in-memory access token; fall back to cookie during initial OAuth hydration.
  const accessToken = tokenStore.getAccessToken() || getCookieValue("token");

  // Do NOT logout here — let the request go out so the response interceptor
  // can catch any 401/403 and run the refresh flow.
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }

  config.baseURL = config.baseURL?.toString()?.toLocaleLowerCase();
  const [firstPart, ...rest] = config.url?.split("?") || [];
  config.url = firstPart?.toString() + (rest.length ? "?" + rest.join("?") : "");

  return config;
};
